// Uren altijd als U:MM tonen (bv. 1,5 uur -> "1:30"), nooit als decimaal getal.
export const formatHM = (hours) => {
  const n = Number(hours);
  if (hours === null || hours === undefined || hours === '' || Number.isNaN(n)) return '';
  const totalMinutes = Math.round(Math.abs(n) * 60);
  const sign = n < 0 ? '-' : '';
  return `${sign}${Math.floor(totalMinutes / 60)}:${String(totalMinutes % 60).padStart(2, '0')}`;
};
export const formatHMFromMinutes = (minutes) => formatHM(Number(minutes) / 60);
